// extracted by mini-css-extract-plugin
module.exports = {"root":"n11-meta_root__qALGl"};